import { graphql, useStaticQuery } from "gatsby";
import { HeroAboutQuery } from "./query.generated";

export type CMSHeroData = HeroAboutQuery["cms"]["site"];

export function useStaticHeroQuery(): CMSHeroData {
  const data = useStaticQuery<HeroAboutQuery>(
    graphql`
      query HeroAbout {
        cms {
          site(hostname: "www.italymondo.com") {
            aboutPage: pages(contentType: "italymondo_about.IMAboutPage") {
              ... on CMS_IMAboutPage {
                __typename
                alertBar {
                  anchorText
                }
                heroDescription
                heroHeadline
                heroImage {
                  alt
                  url
                  urlSharp {
                    childImageSharp {
                      gatsbyImageData(placeholder: BLURRED)
                    }
                  }
                }
                heroPrimaryButton {
                  page {
                    url
                  }
                  title
                }
                heroSecondaryButton {
                  page {
                    url
                  }
                  title
                }
                heroType
                heroVerticalText {
                  name
                }
              }
            }
          }
        }
      }
    `
  );
  return data.cms.site;
}
